import React from 'react';
import '../assets/css/thanks.css';

const Thanks = () => {
  return (
    <div className="thanks-container">
      <div className="thanks-content">
        <div className="thanks-message">
          <h1 className="thanks-title">¡MUCHAS GRACIAS!</h1>
          <h2 className="thanks-subtitle">HEMOS RECIBIDO CORRECTAMENTE TU SOLICITUD</h2>
          <p className="thanks-description">En breve un asesor se contactará contigo.</p>
        </div>
      </div>
    </div>
  );
};

export default Thanks; 